import React from 'react'

const Footer = () => {
  return (
    <div className='bottom-0 text-center mx-auto left-0 right-0 bg-black-500 pb-2'>
        <p className='text-white'>Made with 🤍 by <a className='text-purple-500 underline hover:no-underline' href='https://ndias.info' target='_blank'>Nehemiah Dias</a></p>
    </div>
  )
}

export default Footer